import { FC } from 'react';

type Props = {
  size?: number,
  className?: string,
};

// Stroke-based circular sync arrows (refresh-cw); inherits the parent's text
// colour via currentColor. Outline sibling of the filled refreshIcon.svg /
// cloudSyncIcon.svg assets.
const SyncOutlineIcon: FC<Props> = ({ size = 24, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
    <path d="M21 3v5h-5"></path>
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
    <path d="M8 16H3v5"></path>
  </svg>
);

export default SyncOutlineIcon;
